import React from 'react';
import PropTypes from 'prop-types';

import { PROJECTS_CONFIG } from '@/appConstants';
import { cat } from '@/assets/images';
import Layout from '@/components/Layout';
import Icon from '@/components/Shared/Icon';

import {
  ContactsButton,
  ContactsWrapper,
  MainInfoWrapper,
  StyledImage,
  Text,
  Title,
  Wrapper,
} from './style';

export function FinanceMainSection({ resource }) {
  return (
    <Layout resource={resource} isShowWaitingScreen={false}>
      <Wrapper>
        <MainInfoWrapper>
          <StyledImage src={cat} />
          <Title>Щось пішло не так</Title>
          <Text>Зв’яжіться з нами — з усім допоможемо.</Text>
        </MainInfoWrapper>
        <ContactsWrapper>
          <Title>Залишились питання?</Title>
          <Text>Телефонуйте до нашої служби підтримки</Text>
          <ContactsButton>
            <Icon name="phone" width={16} />
            {PROJECTS_CONFIG[resource].phone}
          </ContactsButton>
        </ContactsWrapper>
      </Wrapper>
    </Layout>
  );
}
FinanceMainSection.propTypes = {
  resource: PropTypes.string.isRequired,
};

export default FinanceMainSection;
